import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentAttributeType } from '../../../driver/models/document/document-attribute-type.model';
import { BaseApiService } from '../../base-service/base-api.service';
import { DocumentSearchResult } from '../../models/document/document-search-result.model';
import { DocumentSearchCriteria } from '../../models/document/document-search-criteria.model';
import { DocumentAttributeTypeMap } from 'app/driver/models/document/document-attribute-type-map.model';
import { DocumentViewModel } from '../../models/document/document-view.model';

@Injectable()
export class DocumentService extends BaseApiService {
    public getDocumentLookups = (): Observable<any> => this.get('Document/Lookups');

    public saveDocument = (documentCollection): Observable<any> => this.post('Document', documentCollection);

    public saveDocuments = (documentCollection: DocumentViewModel[]): Observable<any> => this.post('Document/Bulk', documentCollection);

    public retrieveDocumentMetadata = (data: DocumentSearchCriteria): Observable<{ result: DocumentSearchResult[] }> => this.post('Document/Search', data);

    public retrieveDocumentMetadataForMultipleItemkeys = (data): Observable<any> => this.post('Document/ItemKeys/Search', data);

    public getDocument = (id): Observable<any> => this.get(`Document/${id}`);

    public getDocumentTypesByCategory = (id): Observable<any> => this.get(`Document/DocumentTypes/${parseInt(id)}`);

    public hasEmailForESignature = (customerNumber: number): Observable<any> => this.get(`Document/hasemailforesignature/${customerNumber}`).pipe(map(r => r.result));

    public getDocumentTypeDocumentCategoryTypeMaps = (): Observable<any> => this.get('Document/DocumentTypeDocumentCategoryTypeMaps');

    public deleteDocumentRequirement = (documentRequirementId: number): Observable<any> => this.delete(`Document/DocumentRequirement/${documentRequirementId}`);

    public deleteServiceCompleteDocumentRequirement = (documentRequirementId: number): Observable<any> => this.delete(`Document/DeleteServiceCompleteDocumentRequirement/${documentRequirementId}`);

    public updateDocumentReviewStatus = (documentId: number, documentReviewStatusTypeId: number): Observable<any> => this.post(`Document/Update/Document/${documentId}/ReviewStatus/${documentReviewStatusTypeId}`, null);

    public addDocumentRequirements = (data): Observable<any> => this.post('Document/DocumentRequirements', data);

    public getDocumentIncludingUnsatisfiedDocumentRequirements = (data): Observable<any> => this.post('Document/Search/All', data);

    public getDocumentAttributeTypesByDocumentTypeId = (documentTypeId: number): Observable<{ result: DocumentAttributeType[] }> => this.get(`Driver/Document/Attributes?documentTypeId=${documentTypeId}`);

    public getDocumentAttributeTypes = (): Observable<{ result: DocumentAttributeTypeMap[] }> => this.get('Driver/Document/Attributes/Map');

    public getDocumentAccessControlsByCategory = (accessControlCategoryId): Observable<any> => this.get(`Document/AccessControls/${accessControlCategoryId}`);

    public getScanLaterDocumentRequirements = (businessTransactionNumberId): Observable<any> => this.get(`Document/DocumentRequirements/${businessTransactionNumberId}`);

    public getBulkScanLaterDocumentRequirements = (businessTransactionNumberIds): Observable<any> => this.post('Document/BulkScan', businessTransactionNumberIds);

    public isDocumentsViewRestricted = (customerNumberId, agentId?: number): Observable<any> => {
        if (!!agentId) {
            return this.get(`Document/IsDocumentViewRestricted/customer/${customerNumberId}/agent/${agentId}`);
        } else {
            return this.get(`Document/IsDocumentViewRestricted/${customerNumberId}`);
        }
    };

    public GetDocumentIncludingUnsatisfiedDocumentRequirementsPaginated = (data, pageNumber: number, searchUnsatisfiedDocuments: boolean): Observable<any> => this.post(`Document/Search/All/PageNumber/${pageNumber}/searchUnsatisfiedDocuments/${searchUnsatisfiedDocuments}`, data);
}
